// Product ID to single Variant ID mapping
var tangent_selected_product_map;
const default_addToCartText = "+";
const default_addedToCartText = "&check;";
const default_add_all_to_cart_text = "ADD TO BAG"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No Products Found";
let add_all_to_cart_btn_text = "";

// Map variable to store add all to cart links for each sections
var sections_add_to_cart_map={};
let tangent_recommended_products;

// Add default image url here
var tangent_default_selfie_image_url="";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

let tangent_client_domain_currency;
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkoutDataApiCall(getClientResponseId()));
} else {
  checkoutDataApiCall(getClientResponseId());
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
  tangent_recommended_products = response.products;
  tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

  // Setting Default variant price symbol
  if (tangent_client_domain_currency == "") {
      tangent_client_domain_currency = '$';
  }
  hideLoading();

  const tangent_product_sections = response.product_sections;
  const tangent_text_sections = response.text_sections;
  
  if(tangent_product_sections!=undefined){
    createProductSection(tangent_product_sections, tangent_text_sections);
  }    
  if(response.text_sections!=undefined){
    createTextSection(tangent_product_sections,tangent_text_sections);
  }
  setTangentSelfieExpertText(response.tags);
  if (tangent_recommended_products.length > 0) {
    setProductsToView(tangent_recommended_products, tangent_product_sections, response);
    enableButtonListener();
    loadElementsOnResponseData();           
  }
  else {
      document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
  }

  if (response.description == '') {
      document.querySelector('#tangent-general-text').style.display = "block";
  }
}

function setTangentSelfieExpertText(tags) {
    const recommendationText = generateExpertRecommendationText(tags);
    const el = document.querySelector('#tangent-selfie-expert-text');
    if (el) {
        el.innerHTML = recommendationText;
    }
}

function shouldShowMultiSerum(response) {
  const tags = response.tags || [];
  const productSections = response.product_sections || {};

  // Essentials logic: enable multi-serum when quiz-routine-essentials is present
  // AND there is no ACID section.
  const hasEssentialsTag = tags.includes("quiz-routine-essentials");
  if(hasEssentialsTag){
    return !("section_acid" in productSections);
  }

  // Advanced logic: enable multi-serum when quiz-routine-advanced is present
  // AND at least one of MASK, ACID, TONER, or EMULSION sections is missing.
  const hasAdvancedTag = tags.includes("quiz-routine-advanced");
  const blockingSections = [
    "section_mask",
    "section_acid",
    "section_toner",
    "section_emulsion",
  ];

  const hasAnyMissingSection = blockingSections.some(
    (key) => !(key in productSections)
  );

  return hasAdvancedTag && hasAnyMissingSection;
}

function getIdsToProcessForSection(section, product_ids, showMultiSerum) {
  // For other sections, process all IDs as sent
  if (section !== "section_serum") return product_ids;

  // Serum rules:
  // - showMultiSerum=true: use first two IDs (or one if only one is present)
  // - showMultiSerum=false: use only the first ID
  if (showMultiSerum) {
    if (product_ids.length > 1) return [product_ids[0], product_ids[1]];
    if (product_ids.length === 1) return [product_ids[0]];
    return [];
  }

  if (product_ids.length > 0) return [product_ids[0]];
  return [];
}

function maybeAdjustSerumContainerWidth(section, product_ids, showMultiSerum) {
  if (section !== "section_serum") return;
  if (!showMultiSerum) return;
  if (!Array.isArray(product_ids) || product_ids.length <= 1) return;

  const el = document.getElementById("section_serum_container");
  if (el) el.style.width = "60%";
}

function appendHtmlToFragment(fragment, html) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  while (tempDiv.firstChild) {
    fragment.appendChild(tempDiv.firstChild);
  }
}

function processProductIdForSection(id, productMap, selected_variants, section, fragment) {
  const product = productMap[String(id)];
  if (!product) return false;

  const variant = getSelectedVariant(product, selected_variants);
  const productStatus = isProductAvailable(product, variant);
  if (!productStatus) return false;

  // Track selected product variant
  tangent_selected_product_map[product.id] = variant.id;

  // Update cart link per section
  updateSectionAllToCartLink(variant, section);

  // Build + append product HTML
  const product_html = getProductHTML(product, product.index, variant, section, product);
  appendHtmlToFragment(fragment, product_html);

  return true;
}

function generateExpertRecommendationText(tagKeys) {
  const concernMap = {
    "quiz-fine-lines": "Fine Lines & Wrinkles",
    "quiz-uneven-tone": "Uneven Tone & Texture",
    "quiz-dryness": "Dehydration & Dryness",
    "quiz-dullness": "Dullness",
    "quiz-redness": "Redness",
    "quiz-clogged-pores": "Oil & Clogged Pores",
    "quiz-firmness": "Acne/Blemishes",
    "body_care_purify_pores": "Purify Pores",
    "body_care_smooth_rough_texture": "Smooth Rough/Bumpy Texture",
    "body_care_hydrate_and_moisturize": "Hydrate & Moisturize",
    "body_care_reduce_dryness_irritation": "Reduce Dryness & Irritation",
    "body_care_neutralize_body_odor": "Neutralize Body Odor",
    "body_care_firm_tone": "Firm & Tone",
    "body_care_brighten": "Brighten"
  };

  const routineCountMap = {
    "quiz-routine-simple": "3",
    "quiz-routine-essentials": "4-5",
    "quiz-routine-advanced": "6+"
  };

  // Get primary + secondary concerns
  const concerns = tagKeys
    .filter(key => key in concernMap)
    .map(key => concernMap[key])
    .slice(0, 2);

  let concernsText = "your skin concerns";
  if (concerns.length === 2) {
    concernsText = `<b>${concerns[0]}</b> & <b>${concerns[1]}</b>`;
  } else if (concerns.length === 1) {
    concernsText = `<b>${concerns[0]}</b>`;
  }

  // Get product count (numbers only)
  const productCount =
    routineCountMap[tagKeys.find(key => key in routineCountMap)] || "";

  return `Based on your concerns of ${concernsText}, here are <b>${productCount}</b> Products that our experts recommend for you. Add your custom routine to cart and save 15%.`;
}

function setProductsToView(products, sections, response) {
  const selected_variants = response.selected_variants;
  tangent_selected_product_map = {};
  const max_count = getSectionCount(response.tags)
  
  const showMultiSerum = shouldShowMultiSerum(response);
  // Create a fast lookup map to avoid nested loops
  const productMap = {};
  products.forEach(p => productMap[String(p.id)] = p);

  let count = 0;
  Object.keys(sections).forEach(section => {
    // Hide secondary serum section entirely when multi-serum is not enabled
    if (section === "section_secondary_serum" && !showMultiSerum) {
      const secondaryContainer = document.getElementById(section + "_container");
      if (secondaryContainer) {
        secondaryContainer.style.display = "none";
      }
      return; // skip processing and do not increment count
    }
    const bodyCareSections = ["section_body_care","section_body_wash", "section_body_lotion", "section_body_treatment", "section_body_serum"];
    if(count<max_count || section ==="section_upsell_products" || bodyCareSections.includes(section)){
      const product_ids = sections[section];
      const product_section_grid = document.getElementById(section + "_product_grid");

      let productAddedCount = 0;
      const fragment = document.createDocumentFragment();
      
      for (const id of product_ids) {
        const added = processProductIdForSection(id, productMap, selected_variants, section, fragment);
        if (!added) continue;
        productAddedCount++;
      }

      // Hide section if no valid product added
      if (productAddedCount < 1) {
        document.getElementById(section + "_container").style.display = "none";
      }

      // Mount final fragment in a single DOM update
      product_section_grid.appendChild(fragment);
    }
    if(section !="section_upsell_products"){
      count++;
    }
  });

  addCustomAddAllToCartButtons();
  
}

function getSectionCount(tags) {
  if (!Array.isArray(tags)) return 0;

  // If "quiz-routine-advanced" → show all sections
  if (tags.includes("quiz-routine-advanced")) {
    return 20; 
  }

  // If "quiz-routine-simple" → return 3
  if (tags.includes("quiz-routine-simple")) {
    return 3;
  }

  // If "quiz-routine-essentials" → return 5
  if (tags.includes("quiz-routine-essentials")) {
    return 5;
  }

  // Default fallback
  return 0;
}

function addCustomAddAllToCartButtons(){
  
  const add_to_cart_button = createSectionAddAllToCart("tangent_all_products");

  // update innerHTML once
  add_to_cart_button.innerHTML = getAddAllToCartToText();

  // insert first copy
  const section_upsell = document.getElementById("section_upsell_products_container");
  const retryElement = createRetryQuizElement();

  if(section_upsell){
    section_upsell.prepend(retryElement);
    section_upsell.prepend(add_to_cart_button);
  }

  const bodyCareElement = document.getElementById("section_body_care");
  if(bodyCareElement){
    bodyCareElement.after(retryElement);
    bodyCareElement.after(add_to_cart_button);
  }

  // clone for second location
  const add_to_cart_button_clone = add_to_cart_button.cloneNode(true);
  add_to_cart_button_clone.addEventListener(
    'click',
    () => addAllTocartFunction(add_to_cart_button_clone),
    false
  );

  // insert second copy
  const tangent_custom_tabs = document.getElementById("tangent_custom_tabs");
  tangent_custom_tabs.prepend(add_to_cart_button_clone);

}

function createRetryQuizElement() {
  const wrapper = document.createElement("div");

  const link = document.createElement("a");
  link.href = "/pages/skincare-quiz";

  const text = document.createElement("p");
  text.id = "tangent-try-quiz-button";
  text.textContent = "Retry the quiz";

  link.appendChild(text);
  wrapper.appendChild(link);

  return wrapper;
}

function getAddAllToCartToText() {
  if(sections_add_to_cart_map["tangent_all_products"]){
    const total = sections_add_to_cart_map["tangent_all_products"].total;
    const originalValue = tangent_client_domain_currency + total;
    const discountedValue = tangent_client_domain_currency + (total * 0.85).toFixed(2);

    add_all_to_cart_btn_text = `
      <span style="text-decoration: line-through; opacity: 0.6;">${originalValue}</span>
      &nbsp;
      ${discountedValue}
      &nbsp;&nbsp;&nbsp;
      ${default_add_all_to_cart_text}
    `
    return add_all_to_cart_btn_text;
  }
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => variant.node.id === selectedVariantId).node || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

function getVariantForProduct(product, selected_variants) {
  if (selected_variants[product.id]?.length > 0) {
    const variant_id = selected_variants[product.id][0];
    return product.variants.find(variant => String(variant.id) === variant_id) || product.variants[0];
  }
  return product.variants[0];
}

function getProductHTML(product, index, variant, section) {
  // Setting default / first variant data
  const product_price = variant.price;
  const variantId = extractIdFromGid(variant.id);
  const variant_image_url = getVariantImage(variant, product);
  const variant_product_url = `${product.onlineStoreUrl}?variant=${variantId}`;
  
  const product_type = getProductTypeElement(product,section);
  const product_icon = getProductIconElement(product);

  let variantTitle = "";
  if(variant.title!="Default Title"){
    variantTitle = `<p><span>${variant.title}</span></p>`;
  }
  
  // Product View HTML using template literals
  const product_html = `
    <div class="tangent-product" data-product-index="${index}">
        <div class="tangent-product-type">${product_type} ${product_icon}</div>
        <div style="position:relative">
          <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
            <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
          </a>
          <button id="${variantId}" class="tangent-product-add-button-wrapper tangent-btn-add tangent_add_to_cart_button">
            ${default_addToCartText}
          </button>
        </div>
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
          <p class="tangent-product-title tangent_product_title_text card__heading h5">
            ${product.title} 
          </p>
          ${variantTitle}
        </a>
      <p id="price_tangent_product_${index}" class="tangent_product_price_text">${tangent_client_domain_currency}${product_price}</p>
      ${getProductDetailsDrawer(product)}
    </div>
  `;
  return product_html;
}

function getProductIconElement(product) {
  const iconUrl = product?.product_icon?.reference?.image?.url;

  if (!iconUrl) return '';

  return `
    <div class="product-icon">
      <img src="${iconUrl}" alt="Product Icon" />
    </div>
  `;
}


function getProductDetailsDrawer(product){
  if (!product?.product_details?.value) return "";
  return `
  <details class="tangent-details">
    <summary class="tangent-details-summary">Product details</summary>

    <div class="tangent-details-drawer">
     ${product.product_details.value}
    </div>
  </details>
  `;
}

function getProductTypeElement(product, section) {
  if (section=="section_upsell_products") return "";
  if (!product?.product_type?.value) return "";

  try {
    const parsed = JSON.parse(product.product_type.value);
    const firstType = Array.isArray(parsed) ? parsed[0] : parsed;
    return `<p>${firstType}</p>`;
  } catch {
    return `<p>${product.product_type.value}</p>`;
  }
}


function extractIdFromGid(gid) {
  const match = gid.match(/\/(\d+)$/);
  return match ? match[1] : null;
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(variant, section) {
  const vid = extractIdFromGid(variant.id); // Extract Shopify variant ID number
  if(section!="section_upsell_products"){
    section = "tangent_all_products"
  }
  // Get variant price safely
  const variantPrice =
    parseFloat(
      variant?.contextualPricing?.price?.amount || variant?.price || 0
    ) || 0;

  // Initialize section data if missing
  if (!sections_add_to_cart_map[section]) {
    sections_add_to_cart_map[section] = {
      count: 0,
      cart_link: tangent_client_domain_url + "/cart/add",
      list: [],
      total: 0,
    };
  }

  const sectionData = sections_add_to_cart_map[section];

  // Add only if variant not already in list
  if (!sectionData.list.includes(vid)) {
    sectionData.list.push(vid);
    sectionData.count++;
    sectionData.total += variantPrice;

    // Build a clean cart link
    sectionData.cart_link =
      tangent_client_domain_url +
      "/cart/add?" +
      sectionData.list.map((id) => `id[]=${id}`).join("&");
  }
}


const getVariantImage = (variant, product) => {
  const fallbackImage = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';

  if (variant?.image?.url) {
    return variant.image.url;
  }

  if (product?.images?.nodes?.length > 0 && product.images.nodes[0].url) {
    return product.images.nodes[0].url;
  }

  return fallbackImage;
};

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display){
  document.querySelector("#selfie_canvas").style.display=display;  
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    const add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add("section_add_all_to_cart", section_name+"_add_all_to_cart", "btn");
    add_all_to_cart_button.innerHTML = default_add_all_to_cart_text;
    add_all_to_cart_button.dataset.section = section_name;

    // Enabling listener
    add_all_to_cart_button.addEventListener(
        'click',
        function () { addAllTocartFunction(add_all_to_cart_button); },
        false
    );
    return add_all_to_cart_button;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else if(section_name == "section_additional_product"){
              var section_additional = document.querySelector("#section_additional_content_container_parent");
              section_additional.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    hideLoading();
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                document.querySelector('#tangent_selfie_image').src = tangent_default_selfie_image_url;
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
}

function enableButtonListener() {
    // Listner for section add all to carts
    const all_btns = document.querySelectorAll('.tangent-product-add-button-wrapper');
    for (var b = 0; b < all_btns.length; b++) {
        all_btns[b].addEventListener(
            'click',
            function () { addToCartButtonClick(this); },
            false
        );
    }
}

function loadElementsOnResponseData() {
  const all_elements = document.querySelectorAll('.load-on-data');
  all_elements.forEach(el => (el.style.display = "block"));
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}

function createFormDataFromIds(element) {
  const section = element.getAttribute('data-section');
  let idArray;
  if(section){
    idArray = sections_add_to_cart_map[element.id].list;
  }
  else{
    idArray = [element.id];
  }
  const items = idArray.map(id => {
    const baseItem = { id, quantity: 1 };
    baseItem.properties = {
      _type: section
        ? "tangent-add-all-to-cart"
        : "tangent-add-to-cart",
      _variantIds: idArray.join(',')
    };
    return baseItem;
  });
  return { items };
}

function addToCartButtonClick(element){
  const formData = createFormDataFromIds(element);
  addToCartApi(formData, element);
}


// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(element);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    window.CD_REFRESHCART().then(() => window.CD_OPENCART());
    element.innerHTML = default_addedToCartText;
    setTimeout(() => {
      if(element.classList.contains("section_add_all_to_cart")){
        element.innerHTML = add_all_to_cart_btn_text
      } else {
        element.innerHTML = default_addToCartText;
      }
    }, 4000);
    element.classList.add("added-to-cart-style"); 
  }).catch((error) => {
      console.error('Error:', error);
  });
}

// Custom Design Carousel Script
const tangentCarousel = document.querySelector('.tangent-carousel');
const tangentSlides = document.querySelectorAll('.tangent-slide');
const tangentNext = document.getElementById('tangent-next');
const tangentPrev = document.getElementById('tangent-prev');

let tangentIndex = 1;
let tangentAllSlides;
// Clone first and last for infinite 
if(tangentSlides.length>0){
  const tangentFirstClone = tangentSlides[0].cloneNode(true);
  const tangentLastClone = tangentSlides[tangentSlides.length - 1].cloneNode(true);

  tangentCarousel.appendChild(tangentFirstClone);
  tangentCarousel.prepend(tangentLastClone);

  tangentAllSlides = document.querySelectorAll('.tangent-slide');
  let tangentSlideWidth = tangentSlides[0].clientWidth + 24; // includes gap
  tangentCarousel.style.transform = `translateX(-${tangentSlideWidth * tangentIndex}px)`;

  tangentCarousel.addEventListener('transitionend', () => {
    if (tangentAllSlides[tangentIndex].isEqualNode(tangentFirstClone)) {
      tangentCarousel.style.transition = 'none';
      tangentIndex = 1;
      tangentCarousel.style.transform = `translateX(-${tangentSlideWidth * tangentIndex}px)`;
    }
    if (tangentAllSlides[tangentIndex].isEqualNode(tangentLastClone)) {
      tangentCarousel.style.transition = 'none';
      tangentIndex = tangentAllSlides.length - 2;
      tangentCarousel.style.transform = `translateX(-${tangentSlideWidth * tangentIndex}px)`;
    }
  });

  // Auto-loop
  setInterval(tangentNextSlide, 4000);

  // Buttons
  tangentNext.addEventListener('click', tangentNextSlide);
  tangentPrev.addEventListener('click', tangentPrevSlide);

}

function tangentUpdateActive() {
  if(tangentAllSlides){
    tangentAllSlides.forEach(slide => slide.classList.remove('tangent-active'));
    tangentAllSlides[tangentIndex].classList.add('tangent-active');
  }
}

function tangentNextSlide() {
  if (tangentIndex >= tangentAllSlides.length - 1) return;
  tangentIndex++;
  tangentCarousel.style.transition = 'transform 0.6s ease';
  tangentCarousel.style.transform = `translateX(-${tangentSlideWidth * tangentIndex}px)`;
  tangentUpdateActive();
}

function tangentPrevSlide() {
  if (tangentIndex <= 0) return;
  tangentIndex--;
  tangentCarousel.style.transition = 'transform 0.6s ease';
  tangentCarousel.style.transform = `translateX(-${tangentSlideWidth * tangentIndex}px)`;
  tangentUpdateActive();
}

tangentUpdateActive();